// --------------------------------------------------------------
// Created On: 2024-05-03
// Author: KC Willard
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./Accordion.module.scss";
import { Collapse } from "react-bootstrap";

// Component that creates an accordion card that takes one child component that renders when opened.
export default function Accordion(props: Props): Component {
  // Function to determine the css class of the badge.
  function getBadgeStyle() {
    if (props.isValid === null && props.isActive === false) {
      return styles.accordionBadgeUnvisited;
    } else if (props.isActive === true) {
      return styles.accordionBadgeActive;
    } else if (props.isValid === false && props.isActive === false) {
      return styles.accordionBadgeInvalid;
    } else if (props.isValid === true && props.isActive === false) {
      return styles.accordionBadgeValid;
    }
  }
  // Function to determine the css style of the row.
  function getRowStyle() {
    if (props.isActive) {
      return styles.rowActive;
    } else {
      return styles.rowInactive;
    }
  }

  return (
    <div className={`${styles.body} card shadow-sm`}>
      <div className={`${getRowStyle()} card-header  m-2`} data-test="card-header">
        <h5 className="mb-0">
          {!props.isActive ? (
            <div
              className="row align-items-center"
              onClick={() => props.onChangeIsActive(props.index, true, false)}
              style={{ cursor: "pointer" }}
            >
              <div className="col-auto">
                <div className={getBadgeStyle()}>{props.index}</div>
              </div>
              <div className="col">{props.title}</div>
            </div>
          ) : (
            <div className="row align-items-center">
              <div className="col-auto">
                <div className={getBadgeStyle()}>{props.index}</div>
              </div>
              <div className="col">{props.title}</div>
            </div>
          )}
        </h5>
      </div>
      <Collapse in={props.isActive}>
        <div className="row justify-content-center">
          <div className="col-11">{props.children}</div>
          {props.showContinueButton && (
            <div className={`${styles.buttonRow} row`}>
              <div className="col-6 col-lg-3 pb-3">
                <button
                  className="btn btn-primary"
                  data-test="accordion-continue-button"
                  onClick={() => props.onContinue(props.index, false, true)}
                  style={{ display: "block", width: "100%" }}
                >
                  Continue
                </button>
              </div>
            </div>
          )}
        </div>
      </Collapse>
    </div>
  );
}

interface Props {
  index: number;
  title: string;
  isActive: boolean;
  isValid: boolean | null;
  onChangeIsActive: (index: number, isActive: boolean, isContinue: boolean) => void;
  onContinue: (index: number, isActive: boolean, isContinue: boolean) => void;
  children: Component | Component[];
  showContinueButton: boolean;
}
